import {
	ADD_DISCOUNT_MASTER,
	UPDATE_DISCOUNT_MASTER,
	DELETE_DISCOUNT_MASTER,
	DISCOUNT_MASTERS,
	ADD_DISCOUNT_MASTER_ERROR,
	DISCOUNT_MASTER_DETAILS,
} from "../types/DiscountMasterType";

const initialState = {
	list: null,
	discount: null,
};

const discountMasterReducer = (state = initialState, action) => {
	switch (action.type) {
		case DISCOUNT_MASTERS:
			return { ...state, list: action.payload };
		case ADD_DISCOUNT_MASTER:
			if (!Array.isArray(state.list)) {
				state.list = [];
			}
			const list = [...state.list];
			list.push(action.payload);
			return { ...state, list };

		case DISCOUNT_MASTER_DETAILS:
			return { ...state, discount: action.payload };

		case UPDATE_DISCOUNT_MASTER:
			if (!Array.isArray(state.list)) {
				return state;
			}
			const updatedList = state.list.map((item) =>
				item.id === action.payload.id ? action.payload : item
			);
			return { ...state, list: updatedList };

		case DELETE_DISCOUNT_MASTER:
			if (!Array.isArray(state.list)) {
				return state;
			}
			const filterDiscount = state.list.filter(
				(discount) => discount.id !== parseInt(action.payload) && discount
			);
			return { ...state, list: filterDiscount };

		case ADD_DISCOUNT_MASTER_ERROR:
			return state;
		default:
			return state;
	}
};

export default discountMasterReducer;
